/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';

import OutsideClickHandler from 'react-outside-click-handler';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
// import Select from './select';
import Select from 'react-select-virtualized';
import AppState from '../store/appstate';

function UserDropDown(props) {
  const { t } = useTranslation();
  const {
    data, logout, accounts, switchAccount, selectedAccount, theme,
  } = props;

  const [showMenu, setShowMenu] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false);
  const history = useHistory();
  const username = AppState.useState((s) => s.authentication?.userName);

  const accountsToSort = JSON.parse(JSON.stringify(accounts));

  const handleChange = (selected) => {
    if (!selected) return;
    switchAccount(selected.value);
    setShowMenu(false);
    setShowSwitch(false);
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowMenu(false);
      }}
    >
      <div className="relative inline-block text-left">
        <div>
          <button onClick={() => setShowMenu(!showMenu)} type="button" className="inline-flex justify-center w-full px-4 py-2 font-medium text-sentric-dark-gray focus:outline-none" id="menu-button" aria-expanded="true" aria-haspopup="true">
            {data?.accountname}
            { /* Heroicon name: solid/chevron-down */}
            <svg className="-mr-1 ml-2 h-6 w-6 text-sentric-light-gray" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>

        {showMenu
          && (
            <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
              <div className="py-1 relative" role="none">
                <div className="border-b block w-full text-left px-4 py-2 text-xs text-gray-400" role="menuitem" tabIndex="-1">
                  {t('common:user-menu-username')}
                  {' '}
                  {username}
                </div>
                {accounts?.artistaccounts?.length > 0
                  && (
                    <button id="btnUserSwitchAccount" type="button" onClick={() => setShowSwitch(!showSwitch)} className=" text-gray-700 block w-full text-left px-4 py-2 text-sm focus:outline-none" role="menuitem" tabIndex="-1">
                      {t('common:user-menu-switch')}
                    </button>
                  )}

                {showSwitch
                  && (
                    <div className="p-4 bg-sentric-content-white" style={{ height: '380px' }}>
                      <Select
                        id="txtUserAccountSearch"
                        menuIsOpen
                        className="w-full text-sentric-dark-gray text-sm focus:outline-none"
                        name="artistAccount"
                        placeholder="Search..."
                        value={selectedAccount}
                        onChange={handleChange}
                        options={accountsToSort?.artistaccounts?.sort((a, b) => a.accountname.localeCompare(b.accountname)).map((s) => ({ label: s.accountname, value: s.artistaccountcode }))}
                        search
                      />
                    </div>
                  )}
                {!theme?.data?.disable_add_account_button
                  && (
                    <button id="btnUserAddAccount" type="button" onClick={() => history.push('/add-account-pre')} className="border-t text-gray-700 block w-full text-left px-4 py-2 text-sm" role="menuitem" tabIndex="-1">
                      {t('common:user-menu-add')}
                    </button>
                  )}
                {/* <button type="button" onClick={() => history.push('/add-account-1')} className="border-t text-gray-700 block w-full text-left px-4 py-2 text-sm" role="menuitem" tabIndex="-1">
          Social settings
        </button> */}
                <button id="btnUserSignOut" type="button" onClick={() => logout()} className="border-t text-gray-700 block w-full text-left px-4 py-2 text-sm" role="menuitem" tabIndex="-1">
                  {t('common:user-menu-sign-out')}
                </button>
              </div>
            </div>
          )}
      </div>
    </OutsideClickHandler>

  );
}

export default UserDropDown;
